import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import formStyles from './RegistrationForm.scss';
import styles from './DoctorRegistrationForm.scss';
import {
    Button,
    ButtonLink,
    Form,
    FormFieldWrapper,
    FormTextArea,
    FormTextField,
    GenderDropDownList,
    GraduationDropDownList,
    InputFile,
    LanguagesDropDownList,
    StatesDropDownList,
    TimeWithTimezoneLabel,
    TimezoneDropDownList
} from 'components/controls';
import validateDoctorFields from './validateDoctorFields';
import DefaultAvatar from 'assets/forms/default-avatar.svg';
import moment from 'moment-timezone';
import SpecialtiesPicker from 'components/controls/fields/SpecialtiesPicker';
import ErrorMessage from 'components/controls/form/ErrorMessage';
import FormDatePicker from 'components/controls/fields/FormDatePicker';


export default class DoctorRegistrationForm extends Component {
    static propTypes = {
        onScroll: PropTypes.func.isRequired,
        registrationError: PropTypes.any,
        registrationProcessing: PropTypes.bool,
        fieldValues: PropTypes.any,
        onFieldChange: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onSaveAndExit: PropTypes.func.isRequired
    };

    state = {
        avatar: null
    };

    componentDidMount() {
        const {fieldValues = {}} = this.props;
        if (fieldValues.avatar && !this.state.avatar) {
            this.createFilePreview(fieldValues.avatar);
        }
    }

    componentWillReceiveProps(next) {
        const {fieldValues = {}} = next;
        if (fieldValues.avatar && !this.state.avatar) {
            this.createFilePreview(fieldValues.avatar);
        }
    }

    render() {
        const {
            serverError,
            processing,
            fieldValues,
            onFieldChange,
            onSubmit,
            onSaveAndExit,
            onScroll,
        } = this.props;
        const {avatar} = this.state;

        return (
            <Form className={formStyles.form}
                fieldValues={fieldValues}
                clientValidate={validateDoctorFields}
                serverError={serverError}
                processing={processing}
                onFieldChange={onFieldChange}
                onSubmit={onSubmit}
                onScrollToTop={onScroll}
                scrollOnError
                ref='form'>
                <div className={styles.avatarContainer}>
                    <div className={styles.avatar} style={{backgroundImage: `url(${avatar ? avatar : DefaultAvatar})`}}>
                        <ButtonLink className={styles.fileButton} onClick={() => this.refs.file.select()} />
                    </div>
                    <InputFile accept={'image/jpeg,image/png'}
                        ref='file'
                        onSelect={::this.handleChooseFile}
                               onCancelSelection={::this.handleCancelFile}/>
                    <TimeWithTimezoneLabel className={formStyles.timeLabel}
                        timezone={_.get(fieldValues.timezone, 'name', '')} />

                </div>

                <FormTextField fieldKey='email'
                    type='text'
                    label={loc('email-label')}
                    placeholder={loc('email-placeholder')} />

                <FormTextField fieldKey='password'
                    type='password'
                    label={loc('password-label')}
                    placeholder={loc('password-placeholder')} />

                <FormTextField fieldKey='confirmPassword'
                    type='password'
                    label={loc('confirm-password-label')}
                    placeholder={loc('confirm-password-placeholder')} />


                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormTextField fieldKey='firstName'
                        type='text'
                        label={loc('firstName-label')}
                        placeholder={loc('firstName-placeholder')} />

                    <FormTextField fieldKey='lastName'
                        type='text'
                        label={loc('lastName-label')}
                        placeholder={loc('lastName-placeholder')} />
                </FormFieldWrapper>
                <FormTextField fieldKey='middleName'
                    type='text'
                    label={loc('middleName-label')}
                    placeholder={loc('middleName-placeholder')} />
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <GenderDropDownList fieldKey='gender'
                        canBeNotSelected
                        value={fieldValues.gender}
                        onChange={this.handleDropdownChanged.bind(this, 'gender')} />
                    <FormDatePicker
                        fieldKey='birthDate'
                        label={loc('birthDate-label')}
                        placeholder={'DD-MM-YYYY'}
                        maxDate={moment()}
                        format='MM-DD-YYYY'
                        inputVariant="filled"
                        variant="inline"
                        onChange={(date) => onFieldChange('birthDate', {target: {value: date}})}
                        value={fieldValues.birthDate}
                    />
                </FormFieldWrapper>
                <TimezoneDropDownList fieldKey='timezone'
                    value={fieldValues.timezone}
                    onChange={this.handleDropdownChanged.bind(this, 'timezone')} />

                <GraduationDropDownList fieldKey='graduation'
                    value={fieldValues.graduation}
                    canBeNotSelected
                    onChange={this.handleDropdownChanged.bind(this, 'graduation')} />
                <div className={styles.multipleDropdownContainer}>
                    {fieldValues.languages && fieldValues.languages.map((language, index) => {
                        return (
                            <div key={`language_${index}`} className={styles.tag}>
                                <div>{language}</div>
                                <div className={styles.deleteTag}
                                    onClick={this.handleDeleteTag.bind(this, language, 'languages')} />
                            </div>
                        )
                    })}
                </div>

                <LanguagesDropDownList fieldKey='languages'
                    value={fieldValues.languages}
                    multipleSelection
                    canBeNotSelected
                    multipleFormatter={values => {
                        return values.length === 0 ? loc('choose') : `${values.length} ${values.length === 1 ? 'language' : 'languages'}`
                    }}
                    onChange={::this.handleDropdownChanged.bind(this, 'languages')}/>

                <FormTextField fieldKey='education'
                    type='text'
                    label={loc('education-label')}
                    placeholder={loc('education-placeholder')} />

                <FormTextField
                    fieldKey='graduationYear'
                    label={loc('graduationYear-label')}
                    placeholder={loc('graduationYear-placeholder')}
                    value={fieldValues.graduationYear}
                    type='number'
                />

                <FormTextField fieldKey='graduationAdditional'
                    type='text'
                    label={loc('graduationAdditional-label')}
                    placeholder={loc('graduationAdditional-placeholder')} />

                <FormTextField fieldKey='residency'
                    type='text'
                    label={loc('residency-label')}
                    placeholder={loc('residency-placeholder')} />

                <FormTextField fieldKey='training'
                    type='text'
                    label={loc('training-label')}
                />

                <div className={styles.multipleDropdownContainer}>
                    {fieldValues.licenses && fieldValues.licenses.map((license, index) => {
                        return (
                            <div key={`license_${index}`} className={styles.tag}>
                                <div>{license}</div>
                                <div className={styles.deleteTag}
                                    onClick={this.handleDeleteTag.bind(this, license, 'licenses')}></div>
                            </div>
                        )
                    })}
                </div>
                <StatesDropDownList onChange={::this.handleDropdownChanged.bind(this, 'licenses')} isFormElement/>

                <FormTextField fieldKey='certification'
                    type='text'
                    label={loc('certification-label')}
                    placeholder={loc('certification-placeholder')} />

                <FormTextArea
                    fieldKey='bio'
                    label={loc('bio-label')}
                    placeholder={loc('bio-placeholder')}
                />

                <SpecialtiesPicker
                    fieldKey='specialties'
                    label={loc('specialization-label')}
                    placeholder={loc('choose')}
                    InputProps={{
                        variant: 'filled',
                    }}
                />

                <ErrorMessage type='commonErrors' />

                <div className={formStyles.actionContainer}>
                    <Button type='submit'
                        label={loc('next-step-label')}
                        className={formStyles.submitButton} />
                    <Button type='cancel'
                        label={loc('save-continue-label')}
                        className={formStyles.submitButton}
                        onClick={onSaveAndExit} />
                </div>

            </Form>
        );
    }

    handleDropdownChanged(name, value) {
        const {onFieldChange} = this.props;
        onFieldChange(name, value);
    }

    handleDeleteTag(value, field) {
        const {onFieldChange, fieldValues} = this.props;
        const newValues = fieldValues[field].filter(v => v !== value);
        onFieldChange(field, {target: {value: newValues}});
    }

    handleChooseFile(file) {
        this.createFilePreview(file);
        const {onFieldChange} = this.props;
        onFieldChange('avatar', {target: {value: file}});
    }

    createFilePreview(file) {
        const rd = new FileReader();
        rd.onload = e => {
            this.setState({avatar: e.target.result});
        };
        rd.readAsDataURL(file);
    }

    handleCancelFile() {
        this.setState({avatar: null});
        const {onFieldChange} = this.props;
        onFieldChange('avatar', {target: {value: null}});
    }

    handleChangeDate(key, date) {
        const {onFieldChange} = this.props;
        onFieldChange(key, {target: {value: date}});
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/DoctorRegistrationForm.js